"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaQueries = void 0;
exports.mediaQueries = {
    sasetka: "only screen and (max-width: 575px)",
    ciamajda: "only screen and (min-width: 576px)",
    smerfetka: "only screen and (max-width: 767px)",
    maruda: "only screen and (min-width: 768px)",
    pracus: "only screen and (max-width: 991px)",
    zgrywus: "only screen and (min-width: 992px)",
    wazniak: "only screen and (max-width: 1199px)",
    papaSmerf: "only screen and (min-width: 1200px)",
    gargamel: "only screen and (min-width: 1400px)"
};
